
import DMB125 from '../assets/images/thumbnails/DMB125.png'
import DMBP125 from '../assets/images/preview/DMBP125.png'
import DMBLogo from '../assets/images/logo/LogoDMB.png'
import Creepys6 from '../assets/images/thumbnails/Creepy6.png'
import CreepyP6 from '../assets/images/preview/CreepyP6.png'
import CreepyLogo from '../assets/images/logo/LogoCreepy.png'
import DMB13 from '../assets/images/thumbnails/EP13.png'
import DMBP13 from '../assets/images/preview/DMB13P.png'
import ENTRET from '../assets/images/thumbnails/ENTRET.png'
import ENTREP from '../assets/images/preview/ENTREP.png'
import TMDLOGO from '../assets/images/logo/logotmd.jpg'
import TMDT from '../assets/images/thumbnails/TMD.jpg'
import PCA from '../assets/images/thumbnails/PYA.jpg'

const New = [
  {
    id: 15,
    section: 'DMB',
    title: 'LA OTRA PARTE DEL Episodio 12 : Una Nueva Misión',
    thumbnailUrl: DMB125,
    webUrl: 'https://www.youtube.com/embed/NIDoa2Rprk0', // Add the episode URL
    backgroundImage: DMBP125,
    seriesLogo: DMBLogo,
    description: 'Nuestros heroes siguen su meta de conseguir las esferas sagradas. Pero se encontrarán con viejos y nuevos retos en su camino al siguiente destino...',
  },
  {
    id: 16,
    section: 'DMB',
    title: 'Episodio 13 : La Torre Sagrada',
    thumbnailUrl: DMB13,
    webUrl: 'https://www.youtube.com/embed/q8H8WdX04tM', // Add the episode URL
    backgroundImage: DMBP13,
    seriesLogo: DMBLogo,
    description: '¡Johnny está en peligro! Separado del grupo, Toad tropieza con una persona familiar. Mientras tanto, los errores del pasado asechan a Mario, y nuestros heroes se enfrentan a un dilema que pondrá a prueba su lealtad. ¿Hasta dónde están dispuestos a llegar por las esferas sagradas?',
  },
  {
    id: 8,
    section: 'Extra',
    title: 'El Regreso de TheMarioDimension - Entrevista Completa',
    thumbnailUrl: ENTRET,
    webUrl: 'https://www.youtube.com/embed/zrxr8-TJXP0', // Add the episode URL
    backgroundImage: ENTREP,
    seriesLogo: TMDLOGO,
    description: 'El regreso de TheMarioDimension. Despues de 11 años, Rodrigo regresa a platicarnos no solo de su estado actual, sino tambien de su trayectoria en YouTube. No tengo palabras para describir lo afortunado que me siento de traerles esta entrevista. Gracias @TheZeldaDimension por tomarte el tiempo de participar en este proyecto! Gracias a @ElHasb y @ELROJIZO54 por ayudar en la parte visual y en las preguntas. Y a @LeBasth por la miniatura.',
  },
  {
    id: 6,
    section: 'Creepy',
    title: 'LegoBob || ¿Te Parece Divertido?',
    thumbnailUrl: Creepys6,
    webUrl: 'https://www.youtube.com/embed/Lu_9HJBovso', // Add the episode URL
    backgroundImage: CreepyP6,
    seriesLogo: CreepyLogo,
    description: 'Despues de cobrar venganza contra Rodrigo, LegoBob regresa a terminar con lo que empezó. ¿Logrará Burro resolver este gran misterio a tiempo? \n Este video está basado en la Creepypasta hecha por Rodrigo TheMarioDimension. No es parte del canon de LegoBob ni Dúper Mario Bros.',
  },
  {
    id: 10,
    section: 'Extra',
    title: 'TheMarioDimension',
    thumbnailUrl: TMDT,
    webUrl: 'https://www.youtube.com/embed/Z1p8sNJfG1g', // Add the episode URL
    backgroundImage: TMDT,
    seriesLogo: TMDLOGO,
    description: 'Hey:)',
  },
  {
    id: 11,
    section: 'Extra',
    title: 'Proyectos y Animaciones de TheMarioDimension que nunca salieron',
    thumbnailUrl: PCA,
    webUrl: 'https://www.youtube.com/embed/k8_VZUUEIlg', // Add the episode URL
    backgroundImage: PCA,
    seriesLogo: TMDLOGO,
    description: 'Hola amigos:) el día de hoy les quiero compartir algunos trabajos y material del pasado que encontré entre mis archivos y que nunca llegué a terminar o siquiera sacar a la luz.',
  },
  ];

  export default New;

